import React, { useState } from "react";
import { toast } from "sonner";
import { EnvelopeSimple, Eye } from "@phosphor-icons/react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const TABS = [["media_buyer_email", "Media buyer email"], ["owner_email", "Owner summary"]];

const PreviewBody = ({ data, tab, setTab }) => {
  const mail = data[tab];
  return (
    <>
      <div className="text-xs text-zinc-600" data-testid="weekly-preview-counts">
        Week {data.week_start} to {data.week_end} · {data.will_send} will get it · {data.turned_off} turned it off · {data.no_leads} had no leads
      </div>
      <div className="flex gap-2">
        {TABS.map(([k, label]) => (
          <button key={k} type="button" onClick={() => setTab(k)} data-testid={`weekly-preview-tab-${k}`}
                  className={`border-2 border-black px-2.5 py-1 text-[10px] uppercase tracking-widest transition-colors ${tab === k ? "bg-black text-white" : "bg-white hover:bg-zinc-100"}`}>
            {label}
          </button>
        ))}
      </div>
      {tab === "owner_email" && (
        <div className="text-[11px] text-zinc-600" data-testid="weekly-preview-owner-recipients">
          Goes to: {data.owner_recipients.length ? data.owner_recipients.join(", ") : "no owner email set"}
        </div>
      )}
      {mail ? (
        <>
          <div className="text-xs font-bold" data-testid="weekly-preview-subject">{mail.subject}{mail.name ? ` · sample for ${mail.name}` : ""}</div>
          <iframe title="Weekly email preview" sandbox="" srcDoc={mail.html} className="w-full h-[55vh] border-2 border-black bg-white" data-testid="weekly-preview-frame" />
        </>
      ) : (
        <div className="text-sm text-zinc-600 border-2 border-dashed border-zinc-400 p-6 text-center" data-testid="weekly-preview-empty">
          No media buyer had leads last week, so there's no media buyer email to show.
        </div>
      )}
    </>
  );
};

export const WeeklyReportAdminCard = () => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("media_buyer_email");
  const load = () => {
    setOpen(true);
    setData(null);
    api.get("/admin/media-buyer-weekly/preview")
      .then((r) => setData(r.data))
      .catch((e) => { toast.error(e?.response?.data?.detail || "Couldn't load the preview"); setOpen(false); });
  };
  return (
    <section className="brut-card bg-white p-3 mb-6 flex flex-wrap items-center gap-3" data-testid="weekly-report-admin-card">
      <EnvelopeSimple size={18} weight="bold" />
      <div className="flex-1 min-w-[220px] text-xs text-zinc-600">
        <div className="font-chivo font-black uppercase text-sm tracking-tight text-black">Weekly media buyer report · Mondays 9am Eastern</div>
        Each media buyer gets last week's leads, sold rate and top states with no prices. Owners get one summary with real firm names and revenue.
      </div>
      <button type="button" onClick={load} data-testid="weekly-report-preview-btn"
              className="border-2 border-black px-3 py-1.5 text-[10px] uppercase tracking-widest inline-flex items-center gap-1.5 bg-white hover:bg-black hover:text-white transition-colors">
        <Eye size={12} weight="bold" /> Preview last week's emails
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl rounded-none border-2 border-black" data-testid="weekly-preview-dialog">
          <DialogHeader><DialogTitle className="font-chivo font-black uppercase tracking-tight">Weekly report preview</DialogTitle></DialogHeader>
          {data ? <PreviewBody data={data} tab={tab} setTab={setTab} /> : <div className="label-mono" data-testid="weekly-preview-loading">Loading…</div>}
        </DialogContent>
      </Dialog>
    </section>
  );
};
